import { AxiosError } from 'axios'
import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'
import {
  autodeskLoadSuccess,
  autodeskLoadFailure,
  AUTODESK_LOAD,
  AutodeskConfiguration,
  autodeskHubLoadSuccess,
  autodeskHubLoadFailure,
  AUTODESK_HUB_LOAD,
  AutodeskHubConfiguration
} from './actions'

function* autodeskLoadSaga() {
  try {
    let data: any = {}
    const response: { data: AutodeskConfiguration } = yield call(() =>
      axios.get(`/autodesk`, {})
    )

    data = response && response.data ? response.data : {}

    yield put(autodeskLoadSuccess(data))
  } catch (error) {
    console.error(error)
    yield put(autodeskLoadFailure(error))
  }
}

export function* watch() {
  yield all([takeLatest(AUTODESK_LOAD, autodeskLoadSaga)])
}

function* autodeskHubLoadSaga(action) {
  try {
    let data: any = {}
    const { hubId } = action
    const response: { data: AutodeskHubConfiguration } = yield call(() =>
      axios.get(`/autodesk/hubs/${hubId}`, {})
    )

    data = response && response.data ? response.data : {}

    yield put(autodeskHubLoadSuccess(data))
  } catch (err) {
    const error = err as AxiosError<{ message?: string }>
    yield put(autodeskHubLoadFailure(error?.response?.data))
  }
}

export function* watchHub() {
  yield all([takeLatest(AUTODESK_HUB_LOAD, autodeskHubLoadSaga)])
}
